import React from 'react';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';
export function UrgencySection() {
  return <section className="py-20 bg-gym-dark border-y border-gym-charcoalLight" data-id="element-326">
      <div className="max-w-4xl mx-auto px-4" data-id="element-327">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-328">
          <div className="shrink-0 bg-gym-charcoal p-6 rounded-full border border-gym-charcoalLight" data-id="element-329">
            <Clock size={48} className="text-red-500" data-id="element-330" />
          </div>

          <div className="text-center md:text-left" data-id="element-331">
            <h2 className="text-2xl md:text-4xl font-bold mb-4 uppercase tracking-wide text-white" data-id="element-332">
              Un detalle <span className="text-red-500" data-id="element-333">importante</span>
            </h2>

            <p className="text-lg text-gray-300 mb-4 font-medium" data-id="element-334">
              Los cupos para clases de prueba son limitados. Tenemos grupos
              pequeños por diseño — porque así es como garantizamos atención
              real.
            </p>

            <p className="text-lg text-gray-400 mb-6" data-id="element-335">
              Esto significa que no podemos aceptar a todo el mundo al mismo
              tiempo.
            </p>

            <p className="text-2xl font-bold text-white uppercase tracking-wider bg-red-950/30 inline-block px-6 py-3 rounded-lg border border-red-900/50" data-id="element-336">
              Si estás leyendo esto hoy, actúa hoy.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}